export default {
  integrations: state => {
    return state.integrations;
  },
  integrationById: state => id => {
    const filtered = state.integrations.filter(item => {
      return parseInt(item['id']) === parseInt(id);
    });

    return filtered && filtered.length === 1 ? filtered[0] : null;
  },
  discoveredDevices: state => {
    return state.discoveredDevices;
  },
  discoveredDevicesByIntegration: state => name => {
    return state.discoveredDevices.filter(item => {
      return item.integrationName.toLowerCase() === name.toLowerCase();
    });
  },
  queryLocationResponse: state => {
    return state.queryLocationResponse;
  }
};